module.exports = __webpack_public_path__ + "img/paris-warning.aa84dbcd.png";